export default "__VITE_ASSET__DrrNqufl__"